export default "__VITE_PUBLIC_ASSET__f91179b1__"